import { z } from 'zod';

interface ITCharacteristics {
  label: string;
  id: number | string | null;
}

const ParameterSchema: z.ZodSchema<ITCharacteristics> = z.lazy(() =>
  z.object({
    label: z
      .string()
      .nonempty({ message: 'Пожалуйста, укажите значение' })
      .max(120, { message: 'До 120 символов' }),
    id: z.number().or(z.null()).or(z.string())
  })
);

export const ObjectParameterSchema = z.object({
  id: z.number().or(z.string()),
  name: z
    .string()
    .nonempty({
      message: 'Пожалуйста, укажите название характеристики объекта'
    })
    .max(120, { message: 'До 120 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  measure: z
    .object({
      label: z.string(),
      id: z.number()
    })
    .optional(),
  values: z.array(ParameterSchema)
});
